export class NewUser {
constructor(
  public username?: string,
  public password?: string,
  public passwordAgain?: string
) { }
}
